import { HostLivestream } from './HostLivestream';
import { LivestreamSessionProvider } from './LivestreamSessionContext';

export const HostLivestreamPage = () => (
  <LivestreamSessionProvider>
    <HostLivestream />
  </LivestreamSessionProvider>
);
